import { NavigateOptions, useNavigate, useParams } from 'react-router-dom';

export const useCustomNavigate = () => {
  const { lang } = useParams();
  const navigate = useNavigate();

  const customNavigate = (path: string, options?: NavigateOptions) => {
    navigate(`/${lang}/${path}`, options);
  };  

  return customNavigate;
};
